// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--Eqp4Q","colorSquare":"index-module--colorSquare--2SN6-","headline":"index-module--headline--BLhN9","link":"index-module--link--3a3Th"};